// A burst of stars from a form's final submit button when it is pressed (not the Next and
// Back buttons of a multi-page form). Delegated, so it covers every Formie form, including
// ones added to the page later. The "sending" animation is pure CSS (app.css, "Submit
// button"): the button is tagged here so it only applies to the final submit, and keys off
// Formie's data-formie-loading attribute.
//
// The same stars stream from any element with data-star-burst while it is hovered (the nav's
// Donate button, behind it; "down" fans the stars downwards, for a button at the top of the page).
const COLOURS = ['var(--color-brand)', '#ffb800', '#ffd84d', '#7aa2ff'];
const STAR = '<svg viewBox="0 0 24 24" width="100%" height="100%" aria-hidden="true"><path d="M12 1.5l3 7 7.5.6-5.7 4.9 1.8 7.4L12 17.4 5.4 21.4l1.8-7.4L1.5 9.1 9 8.5z" fill="currentColor"/></svg>';
const COUNT = 14;

const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

// The final submit is the one on the form's last page (any form with a single page has just one).
function isFinalSubmit(button) {
    const pages = button.form?.querySelectorAll('[data-formie-page]');
    const page = button.closest('[data-formie-page]');

    return !pages?.length || !page || page === pages[pages.length - 1];
}

// behind: the stars are added to the button's parent (which must be positioned, with its own
// stacking context) beneath the button, instead of to the page above everything.
function burst(button, direction = 'up', count = COUNT, behind = false) {
    const box = button.getBoundingClientRect();
    const host = behind ? button.parentElement : document.body;
    const originX = behind ? button.offsetLeft : box.left;
    const originY = (behind ? button.offsetTop : box.top) + box.height / 2;
    const scale = behind ? 1.4 : 1;
    const slow = behind ? 2 : 1; // the hover stream drifts more slowly

    for (let i = 0; i < count; i++) {
        const star = document.createElement('span');
        star.className = 'submit-star';
        star.innerHTML = STAR;
        star.style.left = `${originX + box.width / 2 + (Math.random() - 0.5) * box.width * 0.6}px`;
        star.style.top = `${originY}px`;
        star.style.color = behind ? '#fff' : COLOURS[i % COLOURS.length];
        if (behind) {
            star.style.position = 'absolute';
            star.style.zIndex = '0';
        }

        host.appendChild(star);

        // Fan out, mostly upwards (or downwards), then drift down a little as they fade.
        const angle = ((direction === 'down' ? 90 : -90) + (Math.random() - 0.5) * 200) * (Math.PI / 180);
        const distance = 70 + Math.random() * 90;
        const x = Math.cos(angle) * distance;
        const y = Math.sin(angle) * distance;
        const size = (0.6 + Math.random() * 0.9) * scale;
        const spin = (Math.random() - 0.5) * 540;

        star.animate(
            [
                { transform: 'translate(0, 0) scale(0) rotate(0deg)', opacity: 1 },
                { transform: `translate(${x * 0.7}px, ${y * 0.7}px) scale(${size}) rotate(${spin * 0.6}deg)`, opacity: 1, offset: 0.55 },
                { transform: `translate(${x}px, ${y + 30}px) scale(0) rotate(${spin}deg)`, opacity: 0 },
            ],
            { duration: (750 + Math.random() * 450) * slow, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', delay: Math.random() * 80 },
        ).onfinish = () => star.remove();
    }
}

document.addEventListener('click', (event) => {
    const button = event.target.closest?.('.formie-button-submit');

    if (!button || button.disabled || !isFinalSubmit(button)) {
        return;
    }

    // Tag it so the CSS sending animation applies to this button only.
    button.setAttribute('data-final-submit', '');

    if (!reduced.matches) {
        burst(button);
    }
});

// Hover: stars keep streaming from the element while the pointer is over it, and stop when it
// leaves. mouseover/mouseout bubble (pointerenter/leave don't); moves between the element's own
// children are ignored. Without a hovering pointer (touch) it is a single burst on tap.
const canHover = window.matchMedia('(hover: hover)');
const streams = new WeakMap();

document.addEventListener('mouseover', (event) => {
    const target = event.target.closest?.('[data-star-burst]');

    if (!target || target.contains(event.relatedTarget) || reduced.matches || streams.has(target)) {
        return;
    }

    const direction = target.dataset.starBurst === 'down' ? 'down' : 'up';

    if (!canHover.matches) {
        burst(target, direction, COUNT, true);

        return;
    }

    burst(target, direction, 10, true);
    streams.set(target, setInterval(() => burst(target, direction, 4, true), 240));
});

document.addEventListener('mouseout', (event) => {
    const target = event.target.closest?.('[data-star-burst]');

    if (!target || target.contains(event.relatedTarget) || !streams.has(target)) {
        return;
    }

    clearInterval(streams.get(target));
    streams.delete(target);
});
